<div *ngIf="!isLoaded">
    <strong class="mat-toolbar-row margin-top-75-em"> Loading Filters... </strong>
</div>

<div
    *ngIf="isLoaded"
    class="is-flex filter-set-wrapper padding-75-em"
>
    <div class="filter-list">
        <ng-container *ngFor="let prop of properties">
            <div
                *ngIf="prop.isColumn && prop.inFilterSet"
                class="is-half"
            >
                <app-filter-input
                    [property]="prop"
                    [overrideDisabled]="prop.isReadonly"
                ></app-filter-input>
            </div>
            <div *ngIf="!prop.isColumn && prop.inFilterSet && !prop.optionsDeletable">
                <app-filter-input
                    [property]="prop"
                    [overrideDisabled]="prop.isReadonly"
                ></app-filter-input>
            </div>
            <div *ngIf="!prop.isColumn && prop.inFilterSet && prop.optionsDeletable">
                <app-filter-input
                    [property]="prop"
                    [overrideDisabled]="prop.isReadonly"
                    (optionDeleteButtonClicked)="openDeleteOptionConfirmation($event)"
                ></app-filter-input>
            </div>
            <ng-container *ngIf="prop.dynamicFilterParent">
                <ng-container *ngTemplateOutlet="dynamicFilters"></ng-container>
            </ng-container>
        </ng-container>
    </div>

    <div class="is-flex width-100-pct">
        <app-button
            [buttonText]="applyButtonName"
            (buttonClick)="onApplyFilters()"
            [disabled]="!allFiltersSelectedCheck() ? true : null"
            [highlight]="(!isFiltersSame && lastApplied && highlightApplyButton) || areOtherFiltersChanged"
            [class]="'apply-button'"
            [type]="'flat'"
            [isLoading]="isFiltering"
            [icon]="'fa-filter'"
        />
    </div>
    <div class="is-flex width-100-pct">
        <button
            class="button is-danger reset-button"
            (click)="onResetFilters()"
            [attr.disabled]="isFiltering ? true : null"
        >
            <span class="icon">
                <i
                    *ngIf="!isFiltering"
                    class="fas fa-eraser has-text-white"
                    aria-hidden="true"
                ></i>
                <mat-spinner
                    *ngIf="isFiltering"
                    [diameter]="15"
                ></mat-spinner>
            </span>
            <span class="has-text-white">Clear Data</span>
        </button>
    </div>
    <div class="is-flex width-100-pct padding-top-75-em">
        <div
            class="box width-100-pct"
            *ngIf="template.lastLoadedSavedReport; else noSavedReport"
        >
            <app-button
                [buttonText]="'Reports'"
                [type]="'text'"
                [icon]="menuTrigger?.menuOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                [iconPos]="'after'"
                [matMenuTriggerFor]="reportOptions"
                #menuTrigger="matMenuTrigger"
                [class]="'apply-button'"
            />
            <span class="report-name is-flex align-center">
                {{ template.lastLoadedSavedReport.reportName }}
                <app-button
                    [icon]="'fa-solid fa-xmark'"
                    [type]="'icon'"
                    [class]="'margin-left-half-em'"
                    [disabled]="!isFiltersSame && lastApplied"
                    (buttonClick)="onEditExitSavedReport(false)"
                >
                </app-button>
            </span>
        </div>
        <ng-template #noSavedReport>
            <app-button
                [buttonText]="'Reports'"
                [type]="'stroked'"
                [icon]="menuTrigger?.menuOpen ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                [iconPos]="'after'"
                [matMenuTriggerFor]="reportOptions"
                #menuTrigger="matMenuTrigger"
                [class]="'apply-button'"
            />
        </ng-template>
        <mat-menu #reportOptions>
            <div class="dropdown-buttons">
                <app-button
                    [disabled]="isFiltering ? true : null"
                    [buttonText]="'View & Manage Reports'"
                    [icon]="'fa fa-gear'"
                    [type]="'text'"
                    (buttonClick)="onLoadFilters()"
                />
                <app-button
                    [disabled]="!template.lastLoadedSavedReport || !template.lastLoadedSavedReport.isReportOwner"
                    [buttonText]="'Update Current Report'"
                    [icon]="'fas fa-save'"
                    [type]="'text'"
                    (buttonClick)="onEditExitSavedReport(true)"
                />
                <app-button
                    [disabled]="!allFiltersSelectedCheck() ? true : null"
                    [buttonText]="'Save New Report'"
                    [icon]="'fas fa-save'"
                    [type]="'text'"
                    (buttonClick)="onSaveFilters()"
                />
            </div>
        </mat-menu>
    </div>
</div>

<ng-template #dynamicFilters>
    <ng-container *ngFor="let dprop of dynamicProperties">
        <div
            *ngIf="dprop.isColumn && dprop.inFilterSet"
            class="is-half"
        >
            <app-filter-input
                [property]="dprop"
                [overrideDisabled]="dprop.isReadonly"
            ></app-filter-input>
        </div>
        <div *ngIf="!dprop.isColumn && dprop.inFilterSet">
            <app-filter-input
                [property]="dprop"
                [overrideDisabled]="dprop.isReadonly"
            ></app-filter-input>
        </div>
    </ng-container>
</ng-template>
